/**
 * Global motion configuration provider.
 *
 * Wraps the app in framer-motion's MotionConfig with reducedMotion="user",
 * which automatically respects the OS-level "prefers-reduced-motion" setting.
 * When reduced motion is active, motion animations use instant transitions.
 *
 * Tier: All tiers (core infrastructure).
 *
 * @module contexts/MotionProvider
 */

import { MotionConfig } from 'motion/react';

/** Props for MotionProvider component. */
export interface MotionProviderProps {
  /** Child components to wrap with motion configuration. */
  readonly children: React.ReactNode;
}

/**
 * Wraps children in MotionConfig with OS reduced-motion respect.
 *
 * When the user has "Reduce motion" enabled in their OS settings,
 * all motion/framer-motion animations will be suppressed automatically.
 *
 * @param props - MotionProvider props
 * @returns React element wrapping children in MotionConfig
 */
export function MotionProvider({ children }: MotionProviderProps): React.ReactElement {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
